export default __webpack_public_path__ + "static/media/team8.6f454fdb.png";